import { TrackingCategory } from '@bridebook/web/app-basic/lib/analytics/tracking-category';
import { TrackingEvent } from '@bridebook/web/app-basic/lib/analytics/tracking-event';
import { ThunkAction } from '@bridebook/web/app-basic/lib/types';

interface IReadArticleOnLoggedOutPage {
  articleTitle: string;
  articleTags: Array<string>;
  articleCategory: string;
  source?: string;
  readArticleMethod?: string | string[];
  previousPath: string;
}

//Read article on logged out page
export const readArticleOnLoggedOutPage: (
  payload: IReadArticleOnLoggedOutPage,
) => ThunkAction<void> =
  (payload: IReadArticleOnLoggedOutPage): ThunkAction<void> =>
  (_, __, { analyticsService }) =>
    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.ReadArticleOnLoggedOutPage,
      ...payload,
    });
